// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { 
//   createUserWithEmailAndPassword,
//   signInWithPopup,
//   GoogleAuthProvider,
//   updateProfile
// } from "firebase/auth";
// import { auth } from "../firebase";
// import { Eye, EyeOff, Mail, Lock, User, Phone } from "lucide-react";

// const SignUpPage = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     username: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: ""
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//     setError("");
//   };

//   const validateForm = () => {
//     if (formData.password !== formData.confirmPassword) {
//       setError("Passwords do not match");
//       return false;
//     }
//     if (formData.password.length < 6) {
//       setError("Password must be at least 6 characters long");
//       return false;
//     }
//     if (!/^\d{10}$/.test(formData.phone)) {
//       setError("Please enter a valid 10-digit phone number");
//       return false;
//     }
//     return true;
//   };

//   const handleSignUp = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;
    
//     setLoading(true);
//     setError("");

//     try {
//       const userCredential = await createUserWithEmailAndPassword(
//         auth,
//         formData.email,
//         formData.password
//       );
      
//       // Update the user's profile with the username
//       await updateProfile(userCredential.user, {
//         displayName: formData.username
//       });

//       // Here you might want to store additional user data (like phone number)
//       // in your Firebase database

//       navigate("/");
//     } catch (error) {
//       switch (error.code) {
//         case "auth/email-already-in-use":
//           setError("Email already in use");
//           break;
//         case "auth/invalid-email":
//           setError("Invalid email address");
//           break;
//         default:
//           setError("Failed to create account. Please try again.");
//       }
//     }
//     setLoading(false);
//   };

//   const handleGoogleSignUp = async () => {
//     setLoading(true);
//     setError("");
//     const provider = new GoogleAuthProvider();
    
//     try {
//       await signInWithPopup(auth, provider);
//       navigate("/");
//     } catch (error) {
//       setError("Failed to sign up with Google. Please try again.");
//     }
//     setLoading(false);
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-purple-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
//       <div className="max-w-md w-full">
//         <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
//           {/* Header Section with Gradient */}
//           <div className="bg-gradient-to-r from-purple-900 to-purple-700 px-8 pt-8 pb-16">
//             <div className="text-center">
//               <img
//                 src={require("../assets/newlogo.png")}
//                 alt="Ambaari Jewels"
//                 className="h-20 mx-auto mb-4"
//               />
//               <h2 className="text-3xl font-bold text-white">Create Account</h2>
//               <p className="mt-2 text-purple-100">Join us today</p>
//             </div>
//           </div>

//           {/* Form Section */}
//           <div className="px-8 -mt-8">
//             <div className="bg-white rounded-lg shadow-md p-8">
//               <form onSubmit={handleSignUp} className="space-y-6">
//                 <div className="relative">
//                   <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                   <input
//                     type="text"
//                     name="username"
//                     required
//                     value={formData.username}
//                     onChange={handleInputChange}
//                     className="pl-10 w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
//                     placeholder="Username"
//                   />
//                 </div>

//                 <div className="relative">
//                   <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                   <input
//                     type="email"
//                     name="email"
//                     required
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     className="pl-10 w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
//                     placeholder="Email address"
//                   />
//                 </div>

//                 <div className="relative">
//                   <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                   <input
//                     type="tel"
//                     name="phone"
//                     required
//                     value={formData.phone}
//                     onChange={handleInputChange}
//                     className="pl-10 w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
//                     placeholder="Phone number"
//                   />
//                 </div>

//                 <div className="relative">
//                   <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     name="password"
//                     required
//                     value={formData.password}
//                     onChange={handleInputChange}
//                     className="pl-10 w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
//                     placeholder="Password"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowPassword(!showPassword)}
//                     className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
//                   >
//                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>

//                 <div className="relative">
//                   <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
//                   <input
//                     type={showConfirmPassword ? "text" : "password"}
//                     name="confirmPassword"
//                     required
//                     value={formData.confirmPassword}
//                     onChange={handleInputChange}
//                     className="pl-10 w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
//                     placeholder="Confirm password"
//                   />
//                   <button
//                     type="button"
//                     onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                     className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
//                   >
//                     {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                   </button>
//                 </div>

//                 {error && (
//                   <div className="bg-red-50 text-red-500 text-sm rounded-lg p-3">
//                     {error}
//                   </div>
//                 )}

//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="w-full bg-gradient-to-r from-purple-800 to-purple-600 text-white py-3 px-4 rounded-lg hover:opacity-90 transition-all duration-200 disabled:opacity-50 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
//                 >
//                   {loading ? "Creating account..." : "Sign up"}
//                 </button>

//                 <div className="relative my-6">
//                   <div className="absolute inset-0 flex items-center">
//                     <div className="w-full border-t border-gray-200"></div>
//                   </div>
//                   <div className="relative flex justify-center text-sm">
//                     <span className="px-4 bg-white text-gray-500">Or continue with</span>
//                   </div>
//                 </div>

//                 <button
//                   type="button"
//                   onClick={handleGoogleSignUp}
//                   disabled={loading}
//                   className="w-full flex items-center justify-center bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors duration-200 font-medium"
//                 >
//                   <img
//                     src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
//                     alt="Google"
//                     className="w-5 h-5 mr-2"
//                   />
//                   Sign up with Google
//                 </button>

//                 {/* Footer Links */}
//                 <div className="mt-6 text-center">
//                   <p className="text-gray-600">
//                     Already have an account?{" "}
//                     <button
//                       type="button"
//                       onClick={() => navigate("/login")}
//                       className="text-purple-800 hover:text-purple-600 font-medium"
//                     >
//                       Sign in
//                     </button>
//                   </p>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUpPage;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  updateProfile
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { Eye, EyeOff, Mail, Lock, User, Phone } from "lucide-react";

const SignUpPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: ""
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError("");
  };

  const validateForm = () => {
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      return false;
    }
    if (formData.password.length < 6) {
      setError("Password must be at least 6 characters long");
      return false;
    }
    if (!/^\d{10}$/.test(formData.phone)) {
      setError("Please enter a valid 10-digit phone number");
      return false;
    }
    return true;
  };

  const saveUserToFirestore = async (userId, userData) => {
    try {
      await setDoc(doc(db, "users", userId), {
        username: userData.username,
        email: userData.email,
        phone: userData.phone,
        createdAt: new Date().toISOString(),
        lastUpdated: new Date().toISOString(),
        userId: userId,
        accountType: "email",
        isVerified: false,
        profileComplete: true
      });
    } catch (error) {
      console.error("Error saving user data to Firestore:", error);
      throw new Error("Failed to save user data");
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    
    setLoading(true);
    setError("");

    try {
      // Create authentication account
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );
      
      // Update the user's profile with the username
      await updateProfile(userCredential.user, {
        displayName: formData.username
      });

      // Save additional user data to Firestore
      await saveUserToFirestore(userCredential.user.uid, {
        username: formData.username,
        email: formData.email,
        phone: formData.phone
      });

      navigate("/");
    } catch (error) {
      console.error("Signup error:", error);
      switch (error.code) {
        case "auth/email-already-in-use":
          setError("Email already in use");
          break;
        case "auth/invalid-email":
          setError("Invalid email address");
          break;
        default:
          setError("Failed to create account. Please try again.");
      }
    }
    setLoading(false);
  };

  const handleGoogleSignUp = async () => {
    setLoading(true);
    setError("");
    const provider = new GoogleAuthProvider();
    
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Save Google user data to Firestore
      await saveUserToFirestore(user.uid, {
        username: user.displayName,
        email: user.email,
        phone: "", // Google sign-in doesn't provide phone number
        accountType: "google"
      });

      navigate("/");
    } catch (error) {
      console.error("Google signup error:", error);
      setError("Failed to sign up with Google. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-purple-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header Section with Gradient */}
          <div className="bg-gradient-to-r from-purple-900 to-purple-700 px-8 pt-8 pb-16">
            <div className="text-center">
              <img
                src={require("../assets/newlogo.png")}
                alt="Ambaari Jewels"
                className="h-20 mx-auto mb-4"
              />
              <h2 className="text-3xl font-bold text-white">Create Account</h2>
              <p className="mt-2 text-purple-100">Join us today</p>
            </div>
          </div>

          {/* Form Section */}
          <div className="px-8 -mt-8">
            <div className="bg-white rounded-lg shadow-md p-8">
              <form onSubmit={handleSignUp} className="space-y-6">
                <div className="relative">
                  <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="text"
                    name="username"
                    required
                    value={formData.username}
                    onChange={handleInputChange}
                    className="pl-10 w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
                    placeholder="Username"
                  />
                </div>

                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                    className="pl-10 w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
                    placeholder="Email address"
                  />
                </div>

                <div className="relative">
                  <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="tel"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="pl-10 w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
                    placeholder="Phone number"
                  />
                </div>

                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    required
                    value={formData.password}
                    onChange={handleInputChange}
                    className="pl-10 w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
                    placeholder="Password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>

                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    required
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    className="pl-10 w-full py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
                    placeholder="Confirm password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                  >
                    {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>

                {error && (
                  <div className="bg-red-50 text-red-500 text-sm rounded-lg p-3">
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-purple-800 to-purple-600 text-white py-3 px-4 rounded-lg hover:opacity-90 transition-all duration-200 disabled:opacity-50 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                >
                  {loading ? "Creating account..." : "Sign up"}
                </button>

                <div className="relative my-6">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-4 bg-white text-gray-500">Or continue with</span>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={handleGoogleSignUp}
                  disabled={loading}
                  className="w-full flex items-center justify-center bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors duration-200 font-medium"
                >
                  <img
                    src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                    alt="Google"
                    className="w-5 h-5 mr-2"
                  />
                  Sign up with Google
                </button>

                {/* Footer Links */}
                <div className="mt-6 text-center">
                  <p className="text-gray-600">
                    Already have an account?{" "}
                    <button
                      type="button"
                      onClick={() => navigate("/login")}
                      className="text-purple-800 hover:text-purple-600 font-medium"
                    >
                      Sign in
                    </button>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpPage;